import React, { useState, useEffect } from "react";

// components
import VideoModal from "../video-modal/VideoModal";
// css
import "../aboutUs/AboutUs";

// assets
import videoThumbImg from "../../assets/images/VIDEO-WHATISDI.jpg";

const AboutUs = () => {
  const prodKey = process.env.REACT_APP_PRODUCT_KEY;
  const prUrl = process.env.REACT_APP_PUBLICRATES_URL;
  const url = `${prUrl}${prodKey}_site_items.json`;

  const [modal, setModal] = useState(false); // Controls the modal show/hide functionality with a simple boolean.
  const [itemSku, setItemSku] = useState("");
  const [videoType, setVideoType] = useState("");
  const [downloadUrl, setDownloadUrl] = useState("");
  const [hostedVideo, setHostedVideo] = useState("");
  const [hostedVideoDocPath, setHostedVideoDocPath] = useState("");
  const [thumnnailImg, setThumbnailImg] = useState("");

  async function fetchData() {
    const response = await fetch(url);
    if (!response.ok) {
      const message = `An error has occured: ${response.status}`;
      throw new Error(message);
    }
    const data = await response.json();

    // console.log(data.product.location);

    data.product.location
      .filter((typeKey) => typeKey["@key"] === "DIGITAL-INFRASTRUCTURE")
      .map((filteredKey) => {
        // console.log(filteredKey);
        setVideoType(filteredKey);
      });
  }

  // this runs on the close button on the modal. We have to set modalFitem to ('') or else the video will keep playing when you close the modal.
  function renderClose() {
    setModal(false);
    setItemSku("");
    setDownloadUrl("");
    setHostedVideo("");
    setHostedVideoDocPath("");
    setThumbnailImg("");
  }

  useEffect(() => {
    fetchData();
  }, []);
  return (
    <>
      <section id="why-digital-infrastructure">
        <div className="why-di-main-padding">
          <div className="main-margin">
            <div className="why-di-container">
              <div className="why-di-header-content">
                <h1 className="sub-header">What is Digital Infrastructure?</h1>
                <p>
                  Just like roads and bridges carry physical traffic, digital
                  infrastructure carries the digital traffic of our everyday
                  communications. It supports the devices and applications we
                  use to stay connected to essential information, people,
                  communities and businesses.
                </p>
              </div>
              <div>
                <img
                  src={videoThumbImg}
                  alt="video thumbnail"
                  className="video-thumb pointer"
                  onClick={() => {
                    setItemSku(videoType.fitem.item_sku);
                    setDownloadUrl(videoType.fitem.download_url);
                    setHostedVideo(videoType.fitem.hosted_video);
                    setHostedVideoDocPath(
                      videoType.fitem.hosted_video_document_path
                    );
                    setThumbnailImg(videoType.fitem.thumbnail_image);
                    setModal(true);
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        <VideoModal
          show={modal}
          close={renderClose}
          sku={itemSku}
          notHostedLink={downloadUrl}
          isHosted={hostedVideo}
          hostedPath={hostedVideoDocPath}
          thumbnailImg={thumnnailImg}
          isVideo={true}
        />
      </section>
    </>
  );
};

export default AboutUs;
